export default "<div class=\"chart-container\">\r\n    <canvas  id=\"followersChart\">{{ chart }}</canvas>\r\n</div>";